<div class="ape-card">
  <div class="ape-accent"></div>

  <div class="ape-header">
    <span class="ape-title">{{ title }}</span>
    <span class="ape-period">{{ period }}</span>
  </div>

  <div class="ape-summary">
    <!-- KPIs -->
    <div class="ape-kpis">
      <div class="ape-metric">
        <span class="ape-eyebrow">Total APE</span>
        <span class="ape-total">{{ total | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
      </div>
      <div class="ape-metric">
        <span class="ape-eyebrow">Total Cases</span>
        <span class="ape-cases">{{ totalCases | number }}</span>
      </div>
      <!-- Optional slot (e.g. YTD target / shortfall) -->
      <ng-content select="[apeCardExtra]"></ng-content>
    </div>

    <!-- Donut -->
    <div class="ape-donut">
      <svg class="ape-donut-svg" viewBox="0 0 120 120" role="img" aria-label="APE share by carrier">
        <circle class="ape-donut-track" cx="60" cy="60" r="50"></circle>
        @for (s of donutSlices; track s.name) {
          <circle class="ape-donut-seg" cx="60" cy="60" r="50" [style.stroke]="s.color"
            [attr.stroke-dasharray]="s.dash + ' ' + (donutC - s.dash)" [attr.stroke-dashoffset]="s.offset">
            <title>{{ s.name }} — {{ s.ape | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }} · {{ s.pct | number: '1.0-1' }}%</title>
          </circle>
        }
      </svg>
      @if (leader) {
        <div class="ape-donut-center">
          <!-- <span class="ape-donut-value">{{ pct(leader) | number: '1.0-0' }}%</span>
          <span class="ape-donut-eyebrow">{{ leader.name }}</span> -->
        </div>
      }
    </div>

    <!-- Legend -->
    <div class="ape-legend">
      <span class="ape-legend-head">By providers</span>
      @for (s of donutSlices; track s.name) {
        <div class="ape-legend-row">
          <span class="ape-legend-dot" [style.background]="s.color"></span>
          <span class="ape-legend-name">{{ s.name }}</span>
          <span class="ape-legend-ape">{{ s.ape | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
          <span class="ape-legend-pct">{{ s.pct | number: '1.0-1' }}%</span>
        </div>
      }
    </div>
  </div>

  <button type="button" class="ape-toggle" (click)="onToggle()" [attr.aria-expanded]="expanded">
    <span>{{ expanded ? 'Hide providers Breakdown' : 'View by Providers' }}</span>
    <svg class="ape-chevron" [class.open]="expanded" width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
</div>
